var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-15 fill-height"},[_c('v-col',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Proximamente")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }